/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import IdCard from '../IdCard'
import {
	Box,
	HStack,
	VStack,
	Text,
	IconButton,
	useToast,
	Flex,
	Modal,
	ModalOverlay,
	ModalContent,
	ModalHeader,
	ModalFooter,
	ModalCloseButton,
	useDisclosure,
	PinInput,
	PinInputField,
} from '@chakra-ui/react'
import bgImage from '../../assets/images/opaque_bgImage.png'
import { useOrganizationContext } from '../../context/organization.context'
import { useLanguageContext } from '../../context/locale.context'
import { useAuthContext } from '../../context/auth.context'
import SVGIcon from '../../assets/svgIcons'
import { TbEdit } from 'react-icons/tb'
import {
	useUpdateIdcardDetails,
	useVerifyphoneEmail,
} from '../../hooks/asset.hooks'
import { EditUserDetails } from './editUserDetails'
import { formatDateToAnotherFormat } from '../../utils/date.utils'
import ButtonCTA from '../globalComponents/button'
import { Verify } from 'crypto-browserify'

const UserDetails = props => {
	const {
		idCardDetails,
		profileImageData,
		defaultProfilePic,
		orgLogo,
		orgColor,
		toBeDisplayed,
		loadIdCardDetails,
		
	} = props

	const toast = useToast({
		duration: 1000,
	})
	const { isOpen, onOpen, onClose } = useDisclosure()
	const [activityInlineData, setActivityInlineData] = useState({})
	const [isEdit, setIsedit] = useState(false)
	const [displayverifyData, setDisplayVerifyData] = useState('')
	const [verifyDatatype, setVerifyDatatype] = useState('')
	const [verifyOTP, setVerifyOTP] = useState('')
	const [userOTP, setUserOTP] = useState('')
	const [error, setError] = useState(false)
	const [attachmentURl, setattachmentURl] = useState('')
	const [editProfileDetails, setEditprofileDetails] = useState({
		employee_first_name: '',
		employee_alt_phone_num: '',
		employee_alt_email_id: '',
		employee_email_id: '',
		employee_dob: '',
		employee_location: '',
	})
	const [nameErrorMessage, setNameErrorMessage] = useState('')
	const [bloodGroup, setBloodGroup] = useState({})

	const {
		state: { authData },
	} = useAuthContext()

	const {
		state: { orgsColor },
	} = useOrganizationContext()

	const {
		state: { locale },
	} = useLanguageContext()

	const { mutate: UpdateIdcard, isLoading } = useUpdateIdcardDetails()
	const { mutate: verfiyPhoneEmailOtp } = useVerifyphoneEmail()

	const updateEmp = () => {
		if (editProfileDetails.employee_first_name) {
			UpdateIdcard(
				{
					organization_id: authData.organization_id,
					account_id: authData.account_id,
					workforce_id: authData.workforce_id,
					asset_id: authData.asset_id,
					activity_type_category_id: idCardDetails?.activity_type_category_id,
					activity_id: idCardDetails?.activity_id,
					activity_inline_data: JSON.stringify({
						...activityInlineData,
						employee_first_name: editProfileDetails.employee_first_name,
						employee_alt_phone_num: editProfileDetails.employee_alt_phone_num,
						employee_alt_email_id: editProfileDetails.employee_alt_email_id,
						employee_email_id: editProfileDetails.employee_email_id,
						employee_email_verified: 0,
						employee_alt_email_verified: 0,
						employee_alt_phone_num_verified: 0,
						employee_dob: editProfileDetails.employee_dob,
						employee_location: editProfileDetails.employee_location,
						employee_blood_group: bloodGroup?.value || '',
						employee_profile_picture:
							editProfileDetails?.employee_profile_picture ||
							activityInlineData?.employee_profile_picture,
						employee_social_ids: {
							facebook: {},
							instagram: {},
							twitter: {},
							linkedin: {},
						},
					}),
				},
				{
					onSuccess: async res => {
						if (res) {
							const {
								data: { status, response },
							} = res

							if (status === 200) {
								toast({
									title: 'Updated Successfully!',
									status: 'success',
								})
								setIsedit(false)
								loadIdCardDetails()
							}
						}
					},
				}
			)
		} else {
			toast({
				title: 'Please enter full name!',
				status: 'error',
			})
		}
	}

	const { organization_id } = authData
	const {
		employee_first_name,
		employee_organization,
		employee_designation,
		employee_phone_number,
		employee_phone_country_code,
		employee_email_id,
		employee_id,
		employee_blood_group,
		employee_alt_email_id,
		employee_alt_phone_num,
		employee_location,
		employee_dob,
		employee_email_verified,
		employee_alt_email_verified,
		employee_alt_phone_num_verified,
		employee_profile_picture,
	} = activityInlineData

	const { account_name } = idCardDetails

	useEffect(() => {
		if (!!idCardDetails?.activity_inline_data) {
			const { activity_inline_data } = idCardDetails
			setActivityInlineData(idCardDetails.activity_inline_data)
			setEditprofileDetails({
				employee_first_name: activity_inline_data.employee_first_name || '',
				employee_email_id: activity_inline_data.employee_email_id || '',
				employee_alt_phone_num:
					activity_inline_data.employee_alt_phone_num || '',
				employee_alt_email_id: activity_inline_data.employee_alt_email_id || '',
				employee_dob: activity_inline_data.employee_dob || '',
				employee_location: activity_inline_data.employee_location || '',
			})
			if (!!activity_inline_data.employee_blood_group)
				setBloodGroup({
					label: activity_inline_data.employee_blood_group,
					value: activity_inline_data.employee_blood_group,
				})
		}
	}, [idCardDetails])
	const VerifyData = (dataType, countryCode, dataValue, verifyMethod) => {
		if (dataType && dataValue) {
			let plus = verifyMethod === 1 ? '+' : ''
			setDisplayVerifyData(plus + countryCode + ' ' + dataValue)
			setVerifyDatatype(dataType)
			verfiyPhoneEmailOtp(
				{
					phone_number: dataValue,
					country_code: countryCode,
					verification_method: verifyMethod,
					email: dataValue,
				},
				{
					onSuccess: async res => {
						if (res) {
							const {
								data: { status, response },
							} = res

							if (status === 200) {
								setVerifyOTP(response?.verificationCode)
								onOpen()
							}
						}
					},
				}
			)
		}
	}
	const validateOtp = () => {
		setError(false)
		if (+userOTP === verifyOTP) {
			UpdateIdcard(
				{
					organization_id: authData.organization_id,
					account_id: authData.account_id,
					workforce_id: authData.workforce_id,
					asset_id: authData.asset_id,
					activity_type_category_id: idCardDetails?.activity_type_category_id,
					activity_id: idCardDetails?.activity_id,
					activity_inline_data: JSON.stringify({
						...activityInlineData,
						employee_email_verified:
							verifyDatatype === 'employee_email_id'
								? 1
								: employee_email_verified,
						employee_alt_email_verified:
							verifyDatatype === 'employee_alt_email_id'
								? 1
								: employee_alt_email_verified,
						employee_alt_phone_num_verified:
							verifyDatatype === 'employee_alt_phone_num'
								? 1
								: employee_alt_phone_num_verified,
					}),
				},
				{
					onSuccess: async res => {
						if (res) {
							const {
								data: { status, response },
							} = res

							if (status === 200) {
								toast({
									title: 'Verified  Successfully!',
									status: 'success',
								})
								setUserOTP('')
								setError(false)
								setVerifyOTP('')
								setVerifyDatatype('')
								setDisplayVerifyData('')
								onClose()
								//setIsedit(false)
								loadIdCardDetails()
							}
						}
					},
				}
			)
		} else {
			setError(true)
		}
	}
	return (
		<>
			<Modal isOpen={isOpen} onClose={onClose} isCentered size='sm'>
				<ModalOverlay />
				<ModalContent
					pl='4.6rem'
					pr='4.6rem'
					pt='5.125rem'
					pb='5.125rem'
					borderRadius='20px'
				>
					<ModalHeader
						textAlign='left'
						fontWeight='900'
						fontSize='22px'
						color='rgba(0, 0, 0, 0.85)'
					>
						{locale['OTP Verification']}
					</ModalHeader>
					<Text
						fontSize='14px'
						color='rgba(0, 0, 0, 0.85)'
						fontWeight='500'
						opacity='0.6'
					>
						{locale['We have sent a verification code to']}
					</Text>

					<Text
						fontSize='14px'
						color='rgba(0, 0, 0, 0.85)'
						fontWeight='500'
						lineHeight='19px'
						mb='5'
					>
						{displayverifyData}
					</Text>
					<ModalCloseButton m={2} color='#EF3D3D' />
					<HStack w='100%' justifyContent='center'>
						<PinInput
							size='md'
							type='number'
							variant='flushed'
							value={userOTP}
							onChange={value => {
								setUserOTP(value)
							}}
						>
							<PinInputField />
							<PinInputField />
							<PinInputField />
							<PinInputField />
							<PinInputField />
							<PinInputField />
						</PinInput>
					</HStack>
					{error && (
						<Text
							color='red.300'
							fontWeight='400'
							fontSize='sm'
							textAlign='center'
						>
							{
								locale[
									'The OTP entered is invalid/incorrect. Please try again.'
								]
							}
						</Text>
					)}
					<ModalFooter
						justifyContent='center'
						gap='0.8125rem'
						fontWeight='900'
						fontSize='0.875rem'
						pb={0}
					>
						<ButtonCTA
							bg={
								userOTP?.length >= 6
									? 'linear-gradient(225deg, #009B76 0%, #0F7A5E 100%, #24A490 100%)'
									: 'linear-gradient(221.58deg, #828282 -11.33%, #8C8E90 130.62%)'
							}
							borderRadius='18px'
							opacity={userOTP?.length >= 6 ? ' ' : '0.5'}
							color='white'
							h='2.25rem'
							_hover={{
								bg:
									userOTP?.length >= 6
										? 'linear-gradient(225deg, #009B76 0%, #0F7A5E 100%, #24A490 100%)'
										: 'linear-gradient(221.58deg, #828282 -11.33%, #8C8E90 130.62%)',
								color: 'white',
							}}
							onClick={() => validateOtp()}
							isDisabled={userOTP?.length >= 6 ? false : true}
						>
							{locale['Verify Now']}
						</ButtonCTA>
					</ModalFooter>
				</ModalContent>
			</Modal>
			<Box
				w='100vw'
				h='calc(100vh - 70px)'
				display='flex'
				flexDir='row'
				position='relative'
				top='70px'
			>
				{/* id card display screen */}
				<Box
					display='flex'
					w='380px'
					bg=' linear-gradient(203.48deg, #009B76 25.93%, #016F54 100%)'
					h='100%'
					borderTop='1px solid #25b391f0'
				>
					<Box m='auto'>
						<IdCard
							name={employee_first_name}
							org={employee_organization}
							account={account_name}
							asset_type_name={employee_designation}
							defaultProfilePic={!!profileImageData ? profileImageData : defaultProfilePic}
							profileImageData={profileImageData}
							orgLogo={!!orgLogo ? orgLogo : 'defaultOrgIcon'}
							orgColor={!!orgColor ? orgColor : orgsColor[organization_id]}
							isEditCheck={isEdit}
							setEditprofileDetails={setEditprofileDetails}
							editProfileDetails={editProfileDetails}
							nameErrorMessage={nameErrorMessage}
							setattachmentURl={setattachmentURl}
							attachmentURl={attachmentURl}
						/>
					</Box>
				</Box>

				{/* Details screen */}
				<Box display='flex' w='365px' bg='white' h='100%' flexDir='column'>
					<Flex ml='40px' mt='47px' alignItems='center' gap='0.5rem' w='85%'>
						<Box mr='4px' display={'inline-block'}>
							<SVGIcon
								iconName='GreenLogoLineSvg'
								svgProps={{
									width: '36',
									height: '10',
									viewBox: '0 0 36 10',
								}}
							/>
						</Box>{' '}
					{!isEdit	 ? locale['Your Details'] :locale['Edit Your Details'] }
						{!isEdit && (
							<IconButton
								variant='requestSummaryIconButton'
								icon={<TbEdit />}
								onClick={() => {
									setIsedit(true)
								}}
								style={{ marginLeft: 'auto' }}
							/>
						)}
					</Flex>

					{!isEdit ? (
						<VStack mt='50px' ml='40px' alignItems='flex-start' spacing='4'>
							<HStack w='100%' alignItems={'flex-start'}>
								<Box w='26px' h='26px'>
									<SVGIcon
										iconName='CallBigSvg'
										svgProps={{
											width: '24',
											height: '24',
											viewBox: '0 0 24 24',
										}}
										pathProps={{ fill: '#009B76' }}
									/>
								</Box>
								<Box w='70%' pl='14px'>
									<Flex
										fontWeight='500'
										fontSize='11px'
										letterSpacing='0.2px'
										color='#030303'
										gap='0.5rem'
									>
										<Text opacity='0.5'>{locale['Primary Phone Number']}</Text>
										<SVGIcon
											iconName='CheckedSvg'
											svgProps={{
												width: '13',
												height: '12',
												viewBox: '0 0 13 12',
											}}
											style={{ marginLeft: 'auto' }}
											pathProps={{ fill: '#009B76' }}
										/>
									</Flex>
									<Box
										fontWeight='400'
										fontSize='14px'
										letterSpacing='0.2px'
										color='#030303'
									>
										{!!employee_phone_number && (
											<Text color='#000000'>
												{`+${employee_phone_country_code} ${employee_phone_number}`}
											</Text>
										)}
									</Box>
								</Box>
							</HStack>
							<HStack w='100%' alignItems={'flex-start'}>
								<Box w='26px' h='26px'>
									<SVGIcon
										iconName='CallBigSvg'
										svgProps={{
											width: '24',
											height: '24',
											viewBox: '0 0 24 24',
										}}
										pathProps={{ fill: '#009B76' }}
									/>
								</Box>
								<Box w='70%' pl='14px'>
									<Flex
										fontWeight='500'
										fontSize='11px'
										letterSpacing='0.2px'
										color='#030303'
										gap='0.5rem'
									>
										<Text opacity='0.5'>
											{locale['Alternate Phone Number']}
										</Text>
										{employee_alt_phone_num_verified === 1 && (
											<SVGIcon
												iconName='CheckedSvg'
												svgProps={{
													width: '13',
													height: '12',
													viewBox: '0 0 13 12',
												}}
												style={{ marginLeft: 'auto' }}
												pathProps={{ fill: '#009B76' }}
											/>
										)}
									</Flex>
									<Box
										fontWeight='400'
										fontSize='14px'
										letterSpacing='0.2px'
										color='#030303'
									>
										{!!employee_alt_phone_num &&
										!!employee_phone_country_code ? (
											`+${employee_phone_country_code} ${employee_alt_phone_num}`
										) : (
											<Text color='#000000' opacity='0.8'>
												{locale['Not Available']}
											</Text>
										)}
									</Box>
								</Box>
								{!!employee_alt_phone_num &&
									employee_alt_phone_num_verified === 0 && (
										<Box>
											<ButtonCTA
												variant='linkAsButton'
												fontSize='14px'
												fontWeight='900'
												lineHeight='1.375rem'
												verticalAlign='baseline'
												style={{ marginLeft: 'auto' }}
												onClick={() =>
													VerifyData(
														'employee_alt_phone_num',
														employee_phone_country_code,
														employee_alt_phone_num,
														1
													)
												}
											>
												{locale['Verify']}
											</ButtonCTA>
										</Box>
									)}
							</HStack>

							<HStack w='100%' alignItems={'flex-start'}>
								<Box w='26px' h='26px'>
									<SVGIcon
										iconName='MailBigSvg'
										svgProps={{
											width: '24',
											height: '22',
											viewBox: '0 0 24 22',
										}}
										pathProps={{ fill: '#009B76' }}
									/>
								</Box>
								<Box w='70%' pl='14px'>
									<Flex
										fontWeight='500'
										fontSize='11px'
										letterSpacing='0.2px'
										color='#030303'
										gap='0.5rem'
									>
										<Text opacity='0.5'>{locale['Primary email address']}</Text>
										{employee_email_verified === 1 && (
											<SVGIcon
												iconName='CheckedSvg'
												svgProps={{
													width: '13',
													height: '12',
													viewBox: '0 0 13 12',
												}}
												style={{ marginLeft: 'auto' }}
												pathProps={{ fill: '#009B76' }}
											/>
										)}
									</Flex>
									<Box
										fontWeight='400'
										fontSize='14px'
										letterSpacing='0.2px'
										color='#030303'
									>
										{!!employee_email_id ? (
											employee_email_id
										) : (
											<Text color='#000000' opacity='0.8'>
												{locale['Not Available']}
											</Text>
										)}
									</Box>
								</Box>
								{!!employee_email_id && employee_email_verified === 0 && (
									<Box>
										<ButtonCTA
											variant='linkAsButton'
											fontSize='14px'
											fontWeight='900'
											lineHeight='1.375rem'
											verticalAlign='baseline'
											style={{ marginLeft: 'auto' }}
											onClick={() =>
												VerifyData(
													'employee_email_id',
													'',
													employee_email_id,
													3
												)
											}
										>
											{locale['Verify']}
										</ButtonCTA>
									</Box>
								)}
							</HStack>

							<HStack w='100%' alignItems={'flex-start'}>
								<Box w='26px' h='26px'>
									<SVGIcon
										iconName='MailBigSvg'
										svgProps={{
											width: '24',
											height: '22',
											viewBox: '0 0 24 22',
										}}
										pathProps={{ fill: '#009B76' }}
									/>
								</Box>
								<Box w='70%' pl='14px'>
									<Flex
										fontWeight='500'
										fontSize='11px'
										letterSpacing='0.2px'
										color='#030303'
										gap='0.5rem'
									>
										<Text opacity='0.5'>
											{locale['Alternate email address']}
										</Text>
										{employee_alt_email_verified === 1 && (
											<SVGIcon
												iconName='CheckedSvg'
												svgProps={{
													width: '13',
													height: '12',
													viewBox: '0 0 13 12',
												}}
												style={{ marginLeft: 'auto' }}
												pathProps={{ fill: '#009B76' }}
											/>
										)}
									</Flex>
									<Box
										fontWeight='400'
										fontSize='14px'
										letterSpacing='0.2px'
										color='#030303'
									>
										{!!employee_alt_email_id ? (
											employee_alt_email_id
										) : (
											<Text color='#000000' opacity='0.8'>
												{locale['Not Available']}
											</Text>
										)}
									</Box>
								</Box>
								{!!employee_alt_email_id && employee_alt_email_verified === 0 && (
									<Box>
										<ButtonCTA
											variant='linkAsButton'
											fontSize='14px'
											fontWeight='900'
											lineHeight='1.375rem'
											verticalAlign='baseline'
											style={{ marginLeft: 'auto' }}
											onClick={() =>
												VerifyData(
													'employee_alt_email_id',
													'',
													employee_alt_email_id,
													3
												)
											}
										>
											{locale['Verify']}
										</ButtonCTA>
									</Box>
								)}
							</HStack>
							<HStack w='100%' alignItems={'flex-start'}>
								<Box w='26px' h='26px'>
									<SVGIcon
										iconName='IdCardSvg'
										svgProps={{
											width: '20',
											height: '24',
											viewBox: '0 0 20 24',
										}}
										pathProps={{ fill: '#009B76' }}
									/>
								</Box>
								<Box w='80%' pl='14px'>
									<Box
										fontWeight='500'
										fontSize='11px'
										letterSpacing='0.2px'
										color='#030303'
										opacity='0.5'
									>
										{locale['Employee ID']}
									</Box>
									<Box
										fontWeight='400'
										fontSize='14px'
										letterSpacing='0.2px'
										color='#030303'
									>
										{!!employee_id ? (
											employee_id
										) : (
											<Text color='#000000' opacity='0.8'>
												{locale['Not Available']}
											</Text>
										)}
									</Box>
								</Box>
							</HStack>
							<HStack w='100%' alignItems={'flex-start'}>
								<Box w='26px' h='26px'>
									<SVGIcon
										iconName='BdayBigSvg'
										svgProps={{
											width: '24',
											height: '24',
											viewBox: '0 0 24 24',
										}}
										pathProps={{ fill: '#009B76' }}
									/>
								</Box>
								<Box w='80%' pl='14px'>
									<Box
										fontWeight='500'
										fontSize='11px'
										letterSpacing='0.2px'
										color='#030303'
										opacity='0.5'
									>
										{locale['DOB']}
									</Box>
									<Box
										fontWeight='400'
										fontSize='14px'
										letterSpacing='0.2px'
										color='#030303'
									>
										{!!employee_dob ? (
											formatDateToAnotherFormat(
												employee_dob,
												'YYYY-MM-DD',
												'DD MMM YYYY'
											)
										) : (
											<Text color='#000000' opacity='0.8'>
												{locale['Not Available']}
											</Text>
										)}
									</Box>
								</Box>
							</HStack>
							<HStack w='100%' alignItems={'flex-start'}>
								<Box w='26px' h='26px'>
									<SVGIcon
										iconName='BloodGroupBigSvg'
										svgProps={{
											width: '21',
											height: '27',
											viewBox: '0 0 21 27',
										}}
										pathProps={{ fill: '#009B76' }}
									/>
								</Box>
								<Box w='80%' pl='14px'>
									<Box
										fontWeight='500'
										fontSize='11px'
										letterSpacing='0.2px'
										color='#030303'
										opacity='0.5'
									>
										{locale['Blood Group']}
									</Box>
									<Box
										fontWeight='400'
										fontSize='14px'
										letterSpacing='0.2px'
										color='#030303'
									>
										{!!employee_blood_group ? (
											employee_blood_group
										) : (
											<Text color='#000000' opacity='0.8'>
												{locale['Not Available']}
											</Text>
										)}
									</Box>
								</Box>
							</HStack>

							<HStack w='100%' alignItems={'flex-start'}>
								<Box w='26px' h='26px'>
									{/* <Image src={addressIcon} alt='address icon' /> */}
									<SVGIcon
										iconName='AddressBigSvg'
										svgProps={{
											width: '19',
											height: '24',
											viewBox: '0 0 19 24',
										}}
										pathProps={{ fill: '#009B76' }}
									/>
								</Box>
								<Box w='80%' pl='14px'>
									<Box
										fontWeight='500'
										fontSize='11px'
										letterSpacing='0.2px'
										color='#030303'
										opacity='0.5'
									>
										{locale['Address']}
									</Box>
									<Box
										fontWeight='400'
										fontSize='14px'
										letterSpacing='0.2px'
										color='#030303'
									>
										{!!employee_location ? (
											employee_location
										) : (
											<Text color='#000000' opacity='0.8'>
												{locale['Not Available']}
											</Text>
										)}
									</Box>
								</Box>
							</HStack>
						</VStack>
					) : (
						<EditUserDetails
							activityInlineData={activityInlineData}
							setIsedit={setIsedit}
							editProfileDetails={editProfileDetails}
							setEditprofileDetails={setEditprofileDetails}
							updateEmp={updateEmp}
							setBloodGroup={setBloodGroup}
							bloodGroup={bloodGroup}
							setNameErrorMessage={setNameErrorMessage}
							setattachmentURl={setattachmentURl}
						/>
					)}
				</Box>

				{/* what do you want to do screen */}
				<Box
					display='flex'
					flexDir='column'
					flex={1}
					h='100%'
					borderLeft='0.5px solid #e0e0e0'
					backgroundRepeat='no-repeat'
					backgroundPosition='center'
					backgroundSize='cover'
					position='relative'
					backgroundColor='#bbbbbb1a'
					backgroundImage={`url(${bgImage})`}
				>
					{toBeDisplayed}
				</Box>
			</Box>
		</>
	)
}

export default UserDetails
